import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import {
  OnboardingPage,
  OnboardingPageBody,
  OnboardingPageContent,
  OnboardingPageCopy,
} from "@thrivetribe/mvf.ui.organisms.onboarding-page";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./RequestInvite.scss";
import { ImagesUrl } from "configs/EnvironmentConfig";
import { useNavigate } from "react-router-dom";

export const InviteRequestedPage: React.FC = () => {
  let navigate = useNavigate();

  return (
    <div className="request-invite">
      <Helmet>
        <title>Invite Requested - MAN v FAT</title>
      </Helmet>
      <OnboardingPage hideProfile hideSubnav image={`${ImagesUrl}/football.webp`} user={""}>
        <OnboardingPageContent centralizeContent>
          <OnboardingPageBody>
            <a href="/request-invite" className="back-button">
              <ButtonArrow /> Back
            </a>
            <OnboardingPageCopy>
              <h1>WE'LL SORT IT</h1>
              <p>
              If you've got a MAN v FAT account linked to this email, we'll send you an email with a link to set up your Dugout account.
              </p>
              <p>Can't see it? Check your spam folder.</p>             
              <p>
              Still nothing? If you may have signed up to MAN v FAT with a different email, please {" "}
              <Button variant="text"  onClick={() => {
              navigate("/request-invite");
            }}>
                  try again 
                </Button> 
                {" "} with that email. </p>
              <p>
              If you're still having problems, contact{" "}
                <a className="support-email" href="mailto:support@manvfat.com">
                  support@manvfat.com
                </a>
                .              
              </p>            
            </OnboardingPageCopy>
          </OnboardingPageBody>
        </OnboardingPageContent>
      </OnboardingPage>
    </div>
  );
};
